import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
import { CONTACT } from '@/data/content';
import { fadeUp, viewportOnce } from '@/lib/motion';

export default function InstagramCTA() {
  return (
    <section className="relative py-20 sm:py-24 bg-night overflow-hidden" data-testid="instagram-section">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(230,57,70,0.08),transparent_60%)]" />
      <motion.div
        variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce}
        className="relative max-w-4xl mx-auto px-4 sm:px-6 text-center"
      >
        <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-to-tr from-brand-gold via-brand-red to-brand-goldlight p-[2px]">
          <div className="w-full h-full rounded-2xl bg-night flex items-center justify-center">
            <Instagram size={28} className="text-brand-gold" />
          </div>
        </div>
        <h2 className="mt-7 font-display uppercase tracking-tight leading-none text-4xl sm:text-5xl text-white">
          FOLLOW THE <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-goldlight to-brand-gold">ASA JOURNEY</span>
        </h2>
        <p className="mt-4 text-gray-400 max-w-xl mx-auto leading-relaxed">
          Training highlights, match days, camps and community moments — follow the academy on Instagram for the latest from the pitch.
        </p>
        <a href={CONTACT.instagram} target="_blank" rel="noreferrer" data-testid="instagram-follow-button"
          className="mt-8 inline-flex items-center gap-3 bg-gradient-to-r from-brand-goldlight to-brand-gold text-night font-display tracking-widest text-xl px-10 py-4 rounded-sm hover:brightness-110 transition-[filter] duration-300">
          <Instagram size={20} /> FOLLOW {CONTACT.instagramHandle.toUpperCase()}
        </a>
      </motion.div>
    </section>
  );
}
